import React, { useRef, forwardRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

import "overlayscrollbars/css/OverlayScrollbars.css";

import "./scrollbar.override.css";
import styles from "./scrollbar.css";

export const SCROLLBAR_THICKNESS = {
  THIN: "thin",
  MEDIUM: "medium",
  THICK: "thick"
};

function ScrollbarComponent(props) {
  const {
    children,
    className,
    style,
    onScroll,
    onScrollStart,
    onScrollStop,
    scrollRef,
    thickness = SCROLLBAR_THICKNESS.THICK,
    active = true,
    autoHide = false,
    scrollX = false,
    scrollY = true,
    sizeAutoCapable = true
  } = props;
  return active ? (
    <OverlayScrollbarsComponent
      ref={scrollRef}
      className={`${styles.scrollbar} ${className} ${styles[thickness]} ${
        autoHide ? "" : styles.fixedSpace
      }`}
      style={style}
      options={{
        paddingAbsolute: true,
        scrollbars: {
          clickScrolling: true,
          autoHide: autoHide ? "leave" : "never"
        },
        callbacks: {
          onScroll: onScroll,
          onScrollStart: onScrollStart,
          onScrollStop: onScrollStop
        },
        overflowBehavior: {
          x: scrollX ? "scroll" : "visible-hidden",
          y: scrollY ? "scroll" : "visible-hidden"
        },
        sizeAutoCapable: sizeAutoCapable
      }}
    >
      {children}
    </OverlayScrollbarsComponent>
  ) : (
    <div className={className}>{children}</div>
  );
}

ScrollbarComponent.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.any,
  onScroll: PropTypes.func,
  onScrollStart: PropTypes.func,
  onScrollStop: PropTypes.func,
  scrollRef: PropTypes.any,
  active: PropTypes.bool,
  thickness: PropTypes.string,
  scrollX: PropTypes.bool,
  scrollY: PropTypes.bool,
  autoHide: PropTypes.bool,
  sizeAutoCapable: PropTypes.bool
};

export const Scrollbar = forwardRef((props, ref) => {
  const scrollRef = useRef();
  useImperativeHandle(ref, () => {
    return {
      scrollToBottom: (animate) => {
        scrollRef &&
          scrollRef.current &&
          scrollRef.current
            .osInstance()
            .scroll(
              { y: "100%" },
              animate ? 1000 : 0,
              animate && "easeOutBounce"
            );
      },
      scrollToTop: (animate) => {
        scrollRef &&
          scrollRef.current &&
          scrollRef.current
            .osInstance()
            .scroll({ y: 0 }, animate ? 1000 : 0, animate && "easeOutBounce");
      },
      scrollToRight: (animate) => {
        scrollRef &&
          scrollRef.current &&
          scrollRef.current
            .osInstance()
            .scroll(
              { x: "100%" },
              animate ? 1000 : 0,
              animate && "easeOutBounce"
            );
      },
      scrollToLeft: (animate) => {
        scrollRef &&
          scrollRef.current &&
          scrollRef.current
            .osInstance()
            .scroll({ x: 0 }, animate ? 1000 : 0, animate && "easeOutBounce");
      },
      scroll: scrollRef.current.osInstance().scroll,
      target: scrollRef.current.osTarget()
    };
  });
  return <ScrollbarComponent scrollRef={scrollRef} {...props} />;
});

Scrollbar.displayName = "Scrollbar";

Scrollbar.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  style: PropTypes.any,
  onScroll: PropTypes.func,
  onScrollStart: PropTypes.func,
  onScrollStop: PropTypes.func,
  scrollRef: PropTypes.any,
  active: PropTypes.bool,
  thickness: PropTypes.string,
  autoHide: PropTypes.bool,
  scrollX: PropTypes.bool,
  scrollY: PropTypes.bool
};
